import React from "react";
import MaterialTable from '@material-table/core';


function MaUTable({ columns, data, rowClickHandler }) {

  console.log(data);

  // let optimizedData=[];
  // for( let currData of data )
  // {
  //   console.log(currData);
  //   let currentMetric=[];
  //   currentMetric.push(currData.validator);
  //   let sumOfAprs=0;
  //   for (let currApr in currData)
  //   {
  //     // console.log(currApr);
  //     currentMetric.push(currApr.apr);
  //     sumOfAprs+=currApr.apr;
  //   }
  //   // console.log(sumOfAprs);
  // }

  // Render the UI for your table
  return (
    <MaterialTable
      title={`Validators (${data.length})`}
      columns={[
        { title: 'Address', field: 'validator' },
        { title: 'Average Apr (30 days)', field: 'avgapr' ,defaultSort:'desc'},
        { title: 'Day 30', field: '0'},
        { title: 'Day 29', field: '1'},
        { title: 'Day 28', field: '2'},
        { title: 'Day 27', field: '3'},
        { title: 'Day 26', field: '4'},
        { title: 'Day 25', field: '5'},
        { title: 'Day 24', field: '6'},
        { title: 'Day 23', field: '7'},
        { title: 'Day 22', field: '8'},
        { title: 'Day 21', field: '9'},
        { title: 'Day 20', field: '10'},
        { title: 'Day 19', field: '11'},
        { title: 'Day 18', field: '12'},
        { title: 'Day 17', field: '13'},
        { title: 'Day 16', field: '14'},
        { title: 'Day 15', field: '15'},
        { title: 'Day 14', field: '16'},
        { title: 'Day 13', field: '17'},
        { title: 'Day 12', field: '18'},
        { title: 'Day 11', field: '19'},
        { title: 'Day 10', field: '20'},
        { title: 'Day 9', field: '21'},
        { title: 'Day 8', field: '22'},
        { title: 'Day 7', field: '23'},
        { title: 'Day 6', field: '24'},
        { title: 'Day 5', field: '25'},
        { title: 'Day 4', field: '26'},
        { title: 'Day 3', field: '27'},
        { title: 'Day 2', field: '28'},
        { title: 'Day 1', field: '29'},
      ]}
      data={data}
      options={{
        search: true,
        sorting: true,
      }}
      onRowClick={(event,row) =>
        rowClickHandler != null && rowClickHandler(row)
      }

    />
  );
}

export default MaUTable;
